export const settingType = {
  GET_MANAGE_DATE_TIME: "GET_MANAGE_DATE_TIME",
  GET_SETTING_LOADER_TRUE: "GET_SETTING_LOADER_TRUE",
  GET_SETTING_LOADER_FALSE: "GET_SETTING_LOADER_FALSE",
  LOGOUT: "LOGOUT",
};
